"use client";
import type { Dispatch, ReactElement, RefObject, SetStateAction, } from "react";
import type { GanttDependencyLineLayout, ScrollHintState, } from "./gantt-render-selectors";
import type { GanttTooltipProps } from "./GanttTooltip";
import type { GanttLayout } from "./gantt-types";
import { GanttLabelsPane } from "./GanttLabelsPane";
import { GanttTimelineViewport } from "./GanttTimelineViewport";
export interface GanttChartBodyProps {
    labelsPaneRef: RefObject<HTMLDivElement | null>;
    timelineScrollRef: RefObject<HTMLDivElement | null>;
    ganttIdPrefix: string;
    layout: GanttLayout;
    hoveredTaskId: string | null;
    highlightedTaskIds: ReadonlySet<string>;
    dependencyLineLayouts: GanttDependencyLineLayout[];
    tooltipPlacementData: GanttTooltipProps["tooltip"];
    scrollHintState: ScrollHintState;
    isEntranceComplete: boolean;
    onToggleSection: (sectionIndex: number) => void;
    onHoveredTaskIdChange: Dispatch<SetStateAction<string | null>>;
}
export function GanttChartBody({ labelsPaneRef, timelineScrollRef, ganttIdPrefix, layout, hoveredTaskId, highlightedTaskIds, dependencyLineLayouts, tooltipPlacementData, scrollHintState, isEntranceComplete, onToggleSection, onHoveredTaskIdChange, }: GanttChartBodyProps): ReactElement {
    const ganttBodyDebugIdentity = `${ganttIdPrefix}-body`;
    return (
      <div data-el="Cmarkdowngantt/ChartBody/Root" style={{
            display: "flex",
            flex: 1,
            minHeight: 0,
            height: "100%",
            width: "100%",
            overflowY: "hidden",
            overflowX: "hidden",
            borderTop: "1px solid rgba(255,255,255,0.05)",
        }}>
        <GanttLabelsPane labelsPaneRef={labelsPaneRef} layout={layout} hoveredTaskId={hoveredTaskId} highlightedTaskIds={highlightedTaskIds} onToggleSection={onToggleSection}/>
        <GanttTimelineViewport timelineScrollRef={timelineScrollRef} ganttIdPrefix={ganttIdPrefix} layout={layout} hoveredTaskId={hoveredTaskId} highlightedTaskIds={highlightedTaskIds} dependencyLineLayouts={dependencyLineLayouts} tooltipPlacementData={tooltipPlacementData} scrollHintState={scrollHintState} isEntranceComplete={isEntranceComplete} onHoveredTaskIdChange={onHoveredTaskIdChange}/>
      </div>
    );
}
